import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ICompanyMSServiceNote } from '~/types/note/models'

export const {
  getNoteListData: getCompanyMSServiceNoteListData,
  getNoteDataById: getCompanyMSServiceNoteDataById,
  getNoteListDataByParentId: getCompanyMSServiceNoteListDataByCMSSId,
} = makeNoteMockData<ICompanyMSServiceNote>({
  entityName: 'companyMSService',
  storageKeyPrefix: 'companymsservice',
})
